"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBestBlogDashboardUrl = exports.getDefaultContentGroupId = exports.getMessageRenderer = exports.callIfPossible = exports.immutablePick = exports.getRelevantGates = exports.createAction = exports.getRootUrl = exports.getBaseUrl = void 0;

var _Routes = _interopRequireDefault(require("ContentUtils/Routes"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _constants = require("ComposeUI/lib/constants");

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _react = _interopRequireDefault(require("react"));

var getBaseUrl = function getBaseUrl() {
  return '/compose';
};

exports.getBaseUrl = getBaseUrl;

var getRootUrl = function getRootUrl() {
  return getBaseUrl() + "/" + _PortalIdParser.default.get();
}; // redux action creator


exports.getRootUrl = getRootUrl;

var createAction = function createAction(type) {
  return function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      type: type,
      data: data
    };
  };
};

exports.createAction = createAction;

var getRelevantGates = function getRelevantGates(arrayOfGates) {
  var gates = (0, _immutable.Set)(arrayOfGates);
  return gates.filter(function (gate) {
    return _constants.GATES.indexOf(gate) > -1;
  });
};

exports.getRelevantGates = getRelevantGates;

var immutablePick = function immutablePick(data, keysToPick) {
  var keySet = (0, _immutable.Set)(keysToPick).toMap();
  return keySet.map(function (key) {
    return data.get(key);
  });
};

exports.immutablePick = immutablePick;

var callIfPossible = function callIfPossible(prop) {
  if (typeof prop !== 'function') {
    return prop;
  }

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return prop.apply(void 0, args);
};

exports.callIfPossible = callIfPossible;

var getMessageRenderer = function getMessageRenderer(baseKey) {
  return function (key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var fullKey = baseKey + "." + key;

    var value = _I18n.default.lookup(fullKey);

    var hasHTML = /<("[^"]*"|'[^']*'|[^'">])*>/.test(value);
    var ComponentToRender = hasHTML ? _FormattedHTMLMessage.default : _FormattedMessage.default;
    return _react.default.createElement(ComponentToRender, {
      message: fullKey,
      options: options
    });
  };
};

exports.getMessageRenderer = getMessageRenderer;

var getDefaultContentGroupId = function getDefaultContentGroupId(contentGroups, favoriteBlog, post) {
  if (contentGroups.data.size === 0) {
    return 0;
  }

  return _immutable.List.of(post.getIn(['data', 'contentGroupId']), favoriteBlog.favoriteBlog).filter(function (id) {
    return !!id;
  }).find(function (testId) {
    return contentGroups.data.find(function (blog) {
      return blog.id === testId;
    });
  }, undefined, contentGroups.data.first().id);
};

exports.getDefaultContentGroupId = getDefaultContentGroupId;

var getBestBlogDashboardUrl = function getBestBlogDashboardUrl(contentGroups, favoriteBlog, post) {
  return _Routes.default.dashboard(post.get('type'), null, getDefaultContentGroupId(contentGroups, favoriteBlog, post));
};

exports.getBestBlogDashboardUrl = getBestBlogDashboardUrl;